
import axios from "@/axios-instance"
import moment from "moment"
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
// import useEmitter from '@/useEmitter'

export default defineComponent({
  name: "kt-widget-5",
  props: {
    // widgetClasses: String,
    dataCustomer: Object as any,
  },
  data() {
    return {
      isEdit: false,
      arrUsers: [] as any,
      arrGroups: [] as any,
      assign: '',
      assignGroup: '',
      typeOption: false,
      typeOption1: false,
      // idStudent: '',
      disableSubmit: false,
      dataCustomerDefault: {} as any
    }
  },
  computed: {
    user() {
      let temp = window.localStorage.getItem("user")
      return temp ? JSON.parse(temp) : null
    },
  },
  components: {
  },
  methods: {
    defaultData() {
      this.assign = this.dataCustomerDefault.assignee
      this.assignGroup = this.dataCustomerDefault.groupAssignee
      this.isEdit = false
    },
    changeOption() {
      if(!this.typeOption) {
        this.assign = ''
        
      }
      else {
        this.assign = this.dataCustomerDefault.assignee
      }
    },
    changeOption1() {
      if(!this.typeOption1) {
        this.assignGroup = ''
      }
      else {
        this.assignGroup = this.dataCustomerDefault.groupAssignee
      }
    },
    async changeEdit() {
      if (this.isEdit) {
        await this.submit()
      }
      this.isEdit = !this.isEdit

    },
    async submit() {
      // if (this.comment == '') {
      //   return
      // }
      this.disableSubmit = true
      let dataTemp = {
        // "idUser": this.user.id,
        // "idStudent": this.idStudent,
        "assignee": this.assign?this.assign:null,
        "groupAssignee": this.assignGroup?this.assignGroup:null,
      }
      // console.log('dataTemp',dataTemp)
      // return
      await axios.put(`/admission/student/${this.route.params.id}`, dataTemp)
        .then(({ data }) => {
          this.dataCustomerDefault.assignee = dataTemp.assignee
          this.dataCustomerDefault.groupAssignee = dataTemp.groupAssignee
          this.disableSubmit = false
        })
        .catch(({ response }) => {
          console.log('err', response)
        });
    }
  },
  async mounted() {
    // console.log('dataCustomer',this.dataCustomer)
    this.dataCustomerDefault = this.dataCustomer
    this.assign = this.dataCustomer.assignee
    this.assignGroup = this.dataCustomer.groupAssignee
    if(this.assign) {
      this.typeOption = true
    }
    if(this.assignGroup) {
      this.typeOption1 = true
    }
    //this.idStudent = //this.route.params.id as any
    setTimeout(async () => {
       axios.get(`/user/findusersforselect`)
        .then(({ data }) => {
          // console.log('usergrou',data)
          this.arrUsers = data
        })
        .catch(({ response }) => {
          console.log('err', response)
        });
        axios.get(`/groups/`)
        .then(({ data }) => {
          // console.log('data',data)
          this.arrGroups = data
        })
        .catch(({ response }) => {
          console.log('err', response)
        });
    }, 0)

  },
  setup() {
    const route = useRoute()
    return {
      route
    }
  }
});
